import { createContext, useContext } from 'react';
import type { CurrentUser } from './types';

export const AuthContext = createContext<CurrentUser | null>(null);

export function useAuth(): CurrentUser | null {
  return useContext(AuthContext);
}
